import React, { useState } from "react";

import { cn } from "../cn";

export function Avatar({ className, ...props }: React.ComponentProps<"span">) {
  return <span data-slot="avatar" className={cn("tw-relative tw-flex tw-size-10 tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-bg-muted", className)} {...props} />;
}

export type AvatarImageProps = React.ComponentProps<"img">;

export function AvatarImage({ className, src, alt = "", onError, crossOrigin = "use-credentials", ...props }: AvatarImageProps) {
  // Associate the error with its source so changing the image retries it.
  const [failedSrc, setFailedSrc] = useState<AvatarImageProps["src"]>(undefined);
  if (!src || failedSrc === src) return null;
  return (
    <img
      data-slot="avatar-image"
      src={src}
      alt={alt}
      // Avatar endpoints require cookies when the API is on another origin.
      crossOrigin={crossOrigin}
      className={cn("tw-absolute tw-inset-0 tw-z-10 tw-size-full tw-object-cover", className)}
      onError={(e) => {
        setFailedSrc(src);
        onError?.(e);
      }}
      {...props}
    />
  );
}

export function AvatarFallback({ className, ...props }: React.ComponentProps<"span">) {
  return <span data-slot="avatar-fallback" className={cn("tw-flex tw-size-full tw-items-center tw-justify-center tw-text-sm tw-font-medium tw-text-muted-foreground", className)} {...props} />;
}
